import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 d-flex flex-column mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Selecione a concessionária", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterBase = _resolveComponent("FilterBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "crud-mecanicos",
    subtitle: _ctx.label,
    showGoToBack: _ctx.showGoToBack,
    hideFilter: false,
    staticModal: !_ctx.showClose,
    hideClose: !_ctx.showClose,
    disabled: !_ctx.codConcessionariaSelected || _ctx.loading.concessionaria,
    activeModal: _ctx.activeModal,
    closeModal: _ctx.closeModal,
    disabledClick: _ctx.disabledClick,
    onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emiteMudanca()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives((_openBlock(), _createBlock(_component_el_select, {
            modelValue: _ctx.codConcessionariaSelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codConcessionariaSelected) = $event)),
            filterable: "",
            disabled: _ctx.loading.filtrosReprovados || _ctx.optionsConcessionaria.length <= 1,
            placeholder: "Buscar por concessionária",
            clearable: false,
            "no-match-text": "Nenhuma concessionária foi encontrada",
            "no-data-text": "Nenhuma concessionária foi encontrada",
            onVisibleChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.disabledClick = !_ctx.disabledClick))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsConcessionaria, (concessionaria, i) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: i,
                  label: concessionaria.text,
                  value: concessionaria.value,
                  disabled: concessionaria.disabled
                }, null, 8, ["label", "value", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])), [
            [_directive_loading, _ctx.loading.concessionaria]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["subtitle", "showGoToBack", "staticModal", "hideClose", "disabled", "activeModal", "closeModal", "disabledClick"]))
}